import { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { WEIGHT_UNIT } from '../../../../types/enum';
import { convertWeight } from '../../../../lib/utils';
import { FORMAT, formatDate, getLastDate } from '../../../../lib/date';
import usePreference from '../../../../hook/usePreference';
import request from '../../../../lib/request';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const WeightProgress = ({ onClick }) => {
  const { preference } = usePreference();

  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const today = formatDate(new Date());
    const lastDate = formatDate(getLastDate('30'));

    getWeightLogs(lastDate, today);
  }, []);

  const getWeightLogs = async (startDate, endDate) => {
    try {
      const { result } = await request.get(
        `/log/weight?startDate=${startDate}&endDate=${endDate}`
      );
      if (result) {
        setLogs(result);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <button
      className='rounded-xl aspect-video px-3 py-2 bg-secondary w-full'
      onClick={onClick}
    >
      <div className='text-xl font-bold text-white'>
        Weight Progress (
        {preference.weightUnit === WEIGHT_UNIT.LB ? 'lb' : 'kg'})
      </div>
      <div className='mt-2'>
        <Line
          options={{
            responsive: true,
            plugins: {
              legend: {
                display: false,
              },
            },
          }}
          data={{
            labels: logs.map((log) =>
              formatDate(new Date(log.logDate), FORMAT.MONTHDATE)
            ),
            datasets: [
              {
                label: preference.weightUnit === WEIGHT_UNIT.LB ? 'lb' : 'kg',
                data: logs.map((log) =>
                  preference.weightUnit === WEIGHT_UNIT.LB
                    ? convertWeight(log.weight, WEIGHT_UNIT.KG, WEIGHT_UNIT.LB)
                    : log.weight
                ),
                borderColor: 'rgba(255, 255, 255, 0.5)',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
              },
            ],
          }}
        />
      </div>
      <div className='text-xs text-white/50 underline'>Click to record</div>
    </button>
  );
};

export default WeightProgress;
